import { combineReducers, AnyAction } from "@reduxjs/toolkit";
import cashBalList from "./cashBalList/cashBalListDataSlice";
import { resetLoginState } from "../auth/authDataSlice";
import news from "./news/newsDataReducer";
import dividends from "./dividends/dividendsDataSlice";
import securityStatistics from "./securityStatistics/statisticsDataSlice";


const dataReportsReducer = combineReducers({
	cashBalList,
		news,
		dividends,
		securityStatistics,
});

export default (state: any, action: AnyAction) => {
	if (action.type === resetLoginState.type) {
		return dataReportsReducer(undefined, action);
	} else {
		return dataReportsReducer(state, action);
	}
};

